import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useStore } from "../../../stores/store";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { useSubmitData } from "../../../hooks/useSubmitData";
import { useSetMenu } from "../../../hooks/useSetMenu";
import FormLayout from '../../Generic/FormLayout';
import FormInput from '../../Generic/FormInput';
import FormSelect from "../../Generic/FormSelect";
import useAuth from '../../../hooks/useAuth';


const Add = () => {
  const { mainStore } = useStore();
  const { t } = useTranslation();
  const { auth } = useAuth();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();
  useSetMenu(mainStore.UserMenuType, mainStore.UserMenuNo);
  const onError = (errors, e) =>
    enqueueSnackbar(t("onErrorSubmit"), { variant: "error" });

  const schema = yup.object({
    fullName: yup
      .string()
      .required(t('requiredField'))
      .max(150, t('maxLength', { max: 150 })),
    username: yup
      .string()
      .required(t('requiredField'))
      .max(256, t('maxLength', { max: 256 })),
    email: yup
      .string()
      .required(t('requiredField'))
      .max(256, t('maxLength', { max: 256 })),
    password: yup
      .string()
      .required(t('requiredField'))
      .min(6, t('minLength', { min: 6 }))
      .max(50, t('maxLength', { max: 50 })),
    role: yup.string().required(t("selectRequired")),

  });

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const sendData = useSubmitData(axiosPrivate, "/Users", "/User/List");
  // const onSubmit = data => sendData(data);
  const onSubmit = data => {
    sendData(data);
  };
  const onCancel = () => navigate(-1);

  useEffect(() => {
    loadData();
    // eslint-disable-next-line
  }, [t]);

  //#region 
  const [roles, setRoles] = useState([]);
  async function loadData() {
    try {
      const rolesResponse = await axiosPrivate.get("/Roles/SelectOptions");
      setRoles(rolesResponse.data);
    } catch (err) {
      enqueueSnackbar(t("loadDataError"), { variant: "error" });
    }
  }
  const handleRoleChange = selectedOption => {
    setValue("role", selectedOption.label, { shouldValidate: true });
  };
  //#endregion

  return (
    <FormLayout title={t("userCreateTitle")} onSubmit={handleSubmit(onSubmit, onError)} onCancel={onCancel}>
      <FormInput label="userFullName" name="fullName" register={register} errors={errors} />
      <FormInput label="userUsername" name="username" register={register} errors={errors} />
      <FormInput label="userEmail" name="email" register={register} errors={errors} />
      <FormInput label="userPassword" type="password" name="password" register={register} errors={errors} />
      <FormSelect label="userRole" name="role" register={register} errors={errors} options={roles} onChange={handleRoleChange} />
    </FormLayout>
  );
};

export default Add;
